import { toast } from '@shared/ui';

type Translate = (key: string, opts?: Record<string, unknown>) => string;

interface BackendErrorShape {
  error?: { code?: string; details?: { pending_tier?: string | null } };
}

/**
 * Тост на ошибку выставления счёта. Для PAYMENT_PENDING_OTHER_TIER (у юзера уже
 * висит незавершённый чек на ДРУГОЙ тариф — мы держим один чек на юзера, чтобы
 * исключить двойное списание) показываем понятное сообщение вместо общего.
 */
export function showInvoiceError(err: unknown, t: Translate): void {
  const data = (err as { response?: { data?: BackendErrorShape } })?.response?.data;
  if (data?.error?.code === 'PAYMENT_PENDING_OTHER_TIER') {
    const tier = data.error.details?.pending_tier;
    const tierName = tier === 'PRO' ? 'Pro' : tier === 'PREMIUM' ? 'Max' : '';
    toast({
      tone: 'error',
      title: t('billing.pendingOtherTierTitle'),
      message: t('billing.pendingOtherTierMessage', { tier: tierName }),
    });
    return;
  }
  toast({ tone: 'error', title: t('plans.payErrorTitle'), message: t('plans.payErrorMessage') });
}
